/*
   Dashboard view for Device Groups
*/

import _ from 'underscore';
import Radio from 'backbone.radio';
import DashboardLayout from '@/views/dashboard/layout';
import DashboardGroup from '@/views/dashboard/group';
import MapWidget from '@/views/dashboard/widgets/map';
import DeviceCountWidget from '@/views/dashboard/widgets/device_counts';
import DeviceGroupBandwidth from '@/views/dashboard/widgets/bandwidth';
import DeviceGroupWidget from '@/views/dashboard/widgets/devicegroup';
import CurrentDeploymentWidget from '@/views/dashboard/widgets/current_deployment';

    var globalCh = Radio.channel('global');
    var routerCh = Radio.channel('router');

function dashboard(devicegroup) {
    // get dashboard data
    var active_account = globalCh.request('active_account');
    var primary_account = globalCh.request('primary_account');
    var d = new Date();
    var dashboard_date = new Date( Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 11, 59, 59 ) );

    // sometimes, devicegroup.bandwidth.type has not yet been set
    // during initialization, set it here to avoid bug
    devicegroup.bandwidth.type = 'devicegroup_bandwidth';

    // This probably ought to go in its own file
    var available_groups = [
            // Group 1 - mini modules
            {
                columns: 12,
                widgets: [
                {
                    view: DeviceGroupWidget,
                    options: {
                        columns: 4,
                        model: devicegroup
                    }
                },
                {   
                    view: DeviceCountWidget,
                    options: {
                        columns: 3,
                        model: devicegroup
                    }
                },

                {
                    view: CurrentDeploymentWidget,
                    options: {
                        columns: 5,
                        model: devicegroup,
                    }
                    },
                ]
            },
            //  Group 2
            {
                columns: 12,
                widgets: [
                    {
                        view: DeviceGroupBandwidth,
                        options: {
                            columns: 12,
                            model: devicegroup.bandwidth,
                            collection: devicegroup.history,
                            data_types: ['dbo', 'dbi'],
                            title: 'Device Group Bandwidth',
                            ylabel: 'Bytes',
                            devicegroup: devicegroup,
                            colors: ['#21ABD4', '#FF9F4A'],
                            date: dashboard_date
                        }
                    },
                ]
            },
            //  Group 3
            {
                columns: 12,
                widgets: [
                    {
                        view: MapWidget,
                        options: {
                            columns: 12,
                            model: devicegroup
                        }
                    },
                ]
            }

        ];

        var active_groups = [];
        var data_sources = [];

        _(available_groups).each(function(group) {
            var active_widgets = [];

            _(group.widgets).each(function(widget) {
                if (active_account.permits(primary_account, widget.view.prototype.required_permission)) {
                    active_widgets.push(new widget.view(widget.options));

                    if (!widget.options) { return; }
                    // Keep track of the model and/or collection so we can fetch it
                    if (widget.options.model) { data_sources.push(widget.options.model); }
                    if (widget.options.collection) { data_sources.push(widget.options.collection); }
                }
            });

            if (active_widgets.length === 0) { return; }

            group.widgets = active_widgets;

            active_groups.push(new DashboardGroup(group));
        });

        // Abort if we don't have any widgets to show (due to permissions),
        // or if the active account doesn't have ops
        if (active_groups.length === 0 ) {
            globalCh.request('home');
            return;
        }

        // Sync whatever models/collections we're using for widget data
        _.chain(data_sources)
            .uniq()
            .each(function(source) {
                // getUTCMonth is zero based, need to convert it to a non-zero based month for API to understand
                // the month we are asking for
                if ( source.type === 'devicegroup_bandwidth' ){
                    var end_date = (dashboard_date.getUTCMonth() + 1) + '/' + dashboard_date.getUTCDate() + '/' +  dashboard_date.getUTCFullYear();
                    var start_date = null;
                    source.fetch_day(start_date, end_date, 'days').then(function() { source.trigger('change'); });
                } else {
                source.fetch();
                }
        });

        // Show view in app container region
        var app_container = globalCh.request('app_layout');
        app_container.showChildView('container', new DashboardLayout({
            model: devicegroup,
            groups: active_groups
        }));
    var area = 'development';
    if ( devicegroup.type === devicegroup.TYPES_MAP.production 
        || devicegroup.type === devicegroup.TYPES_MAP.factoryfixture 
        || devicegroup.type === devicegroup.TYPES_MAP.dut
    ) {
        area = 'production';
        globalCh.request('show_devicegroup_secondary_nav',
            devicegroup, {
            selected: 'dashboard'
        });
    } else if ( devicegroup.type === devicegroup.TYPES_MAP.pre_production
               || devicegroup.type === devicegroup.TYPES_MAP.pre_factoryfixture
               || devicegroup.type === devicegroup.TYPES_MAP.pre_dut ) {
        area = 'test';
        globalCh.request('show_devicegroup_secondary_nav',
            devicegroup, {
                selected: 'dashboard'
        });
    } else {
        globalCh.request('show_dev_devicegroup_secondary_nav',
            devicegroup, {
            selected: 'dashboard'
        });
    }
    globalCh.request('set_selection', {
        type: devicegroup.type,
        id: devicegroup.id,
        v5_object: devicegroup,
        area: area
    });
    routerCh.request('set_location', 'productDevicegroup', devicegroup.rel.get('product'),  devicegroup);
}

export default dashboard;



